module.exports = __webpack_public_path__ + "img/img_guide_market@3x.5b51e299.png";